import { render } from "./BlockUserPage.vue?vue&type=template&id=2ab5db12&ts=true"
import script from "./BlockUserPage.vue?vue&type=script&lang=ts"
export * from "./BlockUserPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__